import { render, staticRenderFns } from "./VideoOverlay.vue?vue&type=template&id=97386a38&scoped=true"
import script from "./VideoOverlay.vue?vue&type=script&lang=js"
export * from "./VideoOverlay.vue?vue&type=script&lang=js"
import style0 from "./VideoOverlay.vue?vue&type=style&index=0&id=97386a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97386a38",
  null
  
)

export default component.exports